import { render, staticRenderFns } from "./ServicesEdit.vue?vue&type=template&id=93221896&scoped=true&"
import script from "./ServicesEdit.vue?vue&type=script&lang=js&"
export * from "./ServicesEdit.vue?vue&type=script&lang=js&"
import style0 from "./ServicesEdit.vue?vue&type=style&index=0&id=93221896&lang=less&scoped=true&"
import style1 from "./ServicesEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93221896",
  null
  
)

export default component.exports